import React, {useEffect, useState} from "react";
import {useSearchParams} from "react-router-dom";
import Cookies from 'js-cookie';
import HeaderTFAF from "./HeaderTFAF";
import {Button, Container, Modal, Spinner} from "react-bootstrap";
import FooterTFAF from "./FooterTFAF";
import {useLocation} from "react-use";
import {useCookies} from "react-cookie";
import {detectSource} from "../utils/sourceDetection";

const PaymentFailure = props => {
    const [searchParams] = useSearchParams();
    let url = process.env.REACT_APP_MODE !== null && process.env.REACT_APP_MODE !== undefined && process.env.REACT_APP_MODE.includes('dev') ? 'http://localhost:8080/edge' : '/edge';
    const [fullName, setFullName] = useState();
    const [showPopup, setShowPopup] = useState(false);
    const [emailSent, setEmailSent] = useState(false);
    const location = useLocation();
    const [loading, setLoading] = useState(true); // Introduce loading state
    const [cookie, setCookie] = useCookies(['jwt-token']);
    const source = detectSource();
    const isAAPath = source === 'AA' || source === 'AA_MEMBER';
    const isVTNZPath = source === 'VTNZ';
  const baseUrl = window.location.origin;

  useEffect(() => {
        // Track the 'page loaded' event
    if (isAAPath) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'event': 'virtualPageview',
        'virtualUrl': '/aa/paymentfailed',
        'pageTitle': 'Payment Failed'
      });
    }
        //setVehicleData({});
        let renewalId = searchParams.get("id");
        let result = searchParams.get("result");
        let userid = searchParams.get("userid");
        let jwt = Cookies.get('jwt-token');
        fetch(`${url}/prospect/payment/failure?renewalId=${renewalId}&result=${result}&userid=${userid}`, {
            method: "GET",
            mode: "cors",
            headers: new Headers({
                Accept: "application/json",
                "Authorization": `Bearer ${jwt}`
            }),
        })
            .then((response) => response.json())
            .then((json) => {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                  event: 'mbiAutosureEvent',
                  category: 'Payment',
                  status: 'Fail',
                  paymentMethod: 'Card',
                  cardType: 'Unknown',
                });
                setFullName(json.applicant.firstName + " " + json.applicant.surname);
                setLoading(false); // Set loading to false when response is received
            })
            .catch((error) => {
                setLoading(false);
            });
    }, []);

    const onClickEmailQuoteTFAF = () => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "mbiAutosureEvent",
          category: "Email My Quote Submit",
          status: "Success",
          virtualUrl: `${baseUrl}/mbi/paymentfailed`,
          pageTitle: "Choose Your Cover",
        });
        let id = searchParams.get("id");
        const prospectData = {
            id: id
        };

        fetch(`${url}/campaign/policy-renewal/prospect/email-quote`, {
            method: 'POST',
            mode: "cors",
            headers: {
                'Content-Type': 'application/json',
                "Authorization": 'By-Pass-Auth-Create-Prospect'
            },
            body: JSON.stringify(prospectData)
        })
            .then((response) => {
                if (response.ok) {
                    setEmailSent(true);
                    setShowPopup(true);
                }
            })
            .catch((error) => {
                setShowPopup(true);
                console.error('API call error:', error);
            });
    }

  const onClickRedirectTFAF = () => {
    const params = new URLSearchParams(window.location.search);
    const renewalId = encodeURIComponent(params.get('id'));

    window.location.href = `/mbi?id=${renewalId}`;
  };

  const proceedWithPayment = () => {

        let search = window.location.search;
        let params = new URLSearchParams(search);
        let renewalId = encodeURIComponent(params.get('id'));

        let jwt = Cookies.get('jwt-token');
        fetch(url + "/prospect/payment?renewalId=" + renewalId + "&applicantName=" + fullName + "&source="+source, {
            method: "GET",
            mode: "cors",
            headers: new Headers({
                "Content-Type": "application/json",
                "Authorization": `Bearer ${jwt}`
            }),

        })
            .then((response) => {
                response.text().then(function (text) {
                    let jwt = Cookies.get('jwt-token');
                    setCookie('jwt-token', jwt, {
                        path: '/',
                        maxAge: 900
                    });
                    window.location.href = text;
                });


            })
            .catch((err) => console.error("Caught error: ", err));

    }
    const closeWindow = () => {
        setShowPopup(false);
    }
    const closeWindowDirect = () => {
        window.location.href = '/mbi';
    }
    return (
        <>
            <Modal
                show={showPopup}
                onHide={() => setShowPopup(false)}

                backdrop="static"
                size="md"
                keyboard={false}
            >
                <Modal.Header closeButton>
                    {!emailSent ?
                    <Modal.Title ><span style={{color: 'red'}}>Error</span> </Modal.Title>
                        : <Modal.Title ><span style={{color: 'red'}}>Email Sent</span> </Modal.Title> }
                </Modal.Header>

                <Modal.Body className="regularTextStyles">
                    <p>
                        {!emailSent ?
                            <>Error while sending email.</>
                            : <>Email sent successfully.</> }
                    </p>
                </Modal.Body>
                <Modal.Footer>
                    {!emailSent ?
                        <Button variant="secondary" onClick={closeWindow}>
                            Close
                        </Button> :
                        <Button variant="secondary" onClick={closeWindowDirect}>
                            Close
                        </Button>
                    }

                </Modal.Footer>
            </Modal>
            {loading ? (
                // Render loading indication while waiting for API response
                <Spinner animation="border" role="status">
                    <span className="sr-only">Loading...</span>
                </Spinner>
            ) : (
                <>
                        <div style={{minHeight: '100vh', display: 'flex', flexDirection: 'column'}}>
                            <Container fluid style={{flex: 1}}>
                                <HeaderTFAF/>
                                <Container>
                                    <br/><br/>
                                    <p className="subHeadingStyles">Oops!</p>
                                    <p className="regularTextStyles">Sorry your payment has not been successful. Please try
                                        entering your credit card details again.</p>

                                  <button onClick={proceedWithPayment}
                                          style={{
                                            color: 'white',
                                            paddingLeft: 25,
                                            paddingRight: 25,
                                            paddingTop: 13,
                                            paddingBottom: 13,
                                            width: "100%",
                                            maxWidth: "200px",
                                            background: isVTNZPath ? '#E87722' : isAAPath ? '#0d59bf' : '#0073CF',
                                            boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.05)',
                                            borderRadius: 6,
                                            overflow: 'hidden',
                                            border: '1px white solid',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            display: 'inline-flex',
                                            cursor: 'pointer',
                                            opacity: 1
                                          }}>
                                        Proceed to payment
                                  </button>
                                  <br/><br/>
                                    {source === 'TFAF' &&
                                        <Button variant="secondary" onClick={onClickRedirectTFAF} style={{width:"180px"}}>
                                            Go back to quote
                                        </Button>
                                    }
                                    {source !== 'TFAF' && <>
                                        <p className="regularTextStyles">If you would like to email the quote to
                                            yourself, so that you can retrieve it later.</p>
                                      <button onClick={onClickEmailQuoteTFAF} style={{
                                        color: 'white',
                                        paddingLeft: 25,
                                        paddingRight: 25,
                                        paddingTop: 13,
                                        paddingBottom: 13,
                                        width: "100%",
                                        maxWidth: "200px",
                                        background: '#5c636a',
                                        boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.05)',
                                        borderRadius: 6,
                                        overflow: 'hidden',
                                        border: '1px white solid',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        display: 'inline-flex',
                                        cursor: 'pointer',
                                        opacity: 1
                                      }}>
                                            Email Quote
                                      </button>
                                    </>
                                    }
                                    <br/><br/>

                                </Container>
                            </Container>
                            <FooterTFAF/>
                        </div>
                </>
            )}
        </>
    );
}

export default PaymentFailure;
